export const BASE_URL =
  "https://ssvfurcity-api.sbmurban.org/ss/api/cf/";

export const Image_URL = "";
export const UPLOAD_IMAGE_URL = "";

export const HTTP_METHOD = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
};

// https://ssvfurcity-api-staging.sbmurban.org/ss/api/cf/states
// https://ssvfurcity-api-staging.sbmurban.org/ss/api/cf/districts/{stateId}
// https://ssvfurcity-api-staging.sbmurban.org/ss/api/cf/ulbs/district/{districtId}
// https://ssvfurcity-api-staging.sbmurban.org/ss/api/cf/phoneNumberExists/{phoneNumber}
// https://ssvfurcity-api-staging.sbmurban.org/ss/api/cf/questions/{period}/{categoryCode}/{ageGroup}
// https://ssvfurcity-api-staging.sbmurban.org/ss/api/cf/web/save
// https://ssvfurcity-api-staging.sbmurban.org/ss/api/cf/languages

// "https://ssvfurcity-api.sbmurban.org/ss/api/cf/"
